import { css } from "@linaria/core"

import ArrowStroke from "@/illustrations/arrow-stroke.svg?react"
import CardIterate from "@/illustrations/card-iterate.svg?react"
import CardPrototype from "@/illustrations/card-prototype.svg?react"
import CardRun from "@/illustrations/card-run.svg?react"
import CardShare from "@/illustrations/card-share.svg?react"
import ChangedFilesEmpty from "@/illustrations/changed-files-empty.svg?react"
import FigmaConnectBg from "@/illustrations/figma-connect-bg.svg?react"
import FigmaStroke from "@/illustrations/figma-stroke.svg?react"
import HmmError from "@/illustrations/hmm-error.svg?react"
import MatterStroke from "@/illustrations/matter-stroke.svg?react"
import VersionsEmpty from "@/illustrations/versions-empty.svg?react"

export {
  ArrowStroke,
  CardIterate,
  CardPrototype,
  CardRun,
  CardShare,
  ChangedFilesEmpty,
  FigmaConnectBg,
  FigmaStroke,
  HmmError,
  MatterStroke,
  VersionsEmpty
}

export const SvgIllustration = css`
  max-width: 100%;
`